import React, { useEffect, useState } from 'react';
import { useTranslation } from '../../i18n/LanguageContext';
import './MessageBox.css';

interface MessageBoxProps {
  message: string;
  visible: boolean;
  duration?: number;
}

const MessageBox: React.FC<MessageBoxProps> = ({
  message,
  visible,
  duration
}) => {
  const [isVisible, setIsVisible] = useState(visible);
  // フェードアウトのアニメーション中はDOMに残すためのフラグ
  const [shouldRender, setShouldRender] = useState(visible);
  const { language } = useTranslation();

  useEffect(() => {
    setIsVisible(visible);
    if (visible) setShouldRender(true);

    if (visible && duration && duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [visible, duration, message]);

  // 非表示になったらフェードアウト（0.3s）を待ってからアンマウント
  useEffect(() => {
    if (isVisible) return;
    const timer = setTimeout(() => setShouldRender(false), 300);
    return () => clearTimeout(timer);
  }, [isVisible]);

  if (!shouldRender || !message) return null;

  const characterName = language === 'ja' ? '空' : 'Sora';

  return (
    <div className={`message-box ${isVisible ? 'fade-in' : 'fade-out'}`}>
      <div className="message-box-name">{characterName}</div>
      <div className="message-box-text">{message}</div>
    </div>
  );
};

export default MessageBox;
